<!-- TODO: Finalize this component and remove comments-->
<label
  [translatable]="{
    transKey: labelTranslationKey,
    modEnum: labelTranslationModuleEnum
  }"
  *ngIf="!!title"
  class="form-label"
>
  {{ title }}
  <span
    *ngIf="isRequired"
    [ngClass]="{ 'astrix-red': isRequired, 'no-astrix': !isRequired }"
  >
    *
  </span>
</label>

<div
  [translatable]="{
    transKey: placeholderTranslationKey,
    modEnum: placeholderTranslationModuleEnum
  }"
>
  <!-- <ng-select
    class="input-select w-100"
    [ngClass]="{ valid: control?.valid }"
    [dir]="lang === 'en' ? 'ltr' : 'rtl'"
    [dropdownPosition]="dropdownPosition"
    [readonly]="disabled"
    [clearable]="clearable"
    [searchable]="search"
    [placeholder]="placeholder"
    [bindValue]="bindVlaue"
    [bindLabel]="bindLabel"
    [items]="itemsList"
    [multiple]="multiple"
    [compareWith]="compareWith ?? null"
    [loading]="loadingValue"
    [notFoundText]="noItemsText | translate"
    (change)="changeValue($event); change.emit($event)"
    (blur)="focus()"
    (clear)="clearHandler($event)"
    [(ngModel)]="initValue"
    (focus)="_onfocus()"
    (search)="searchValue($event)"
  ></ng-select> -->
  <nz-select
  [(ngModel)]="listOfSelectedValue"
  (nzScrollToBottom)="loadMore()"
  [nzPlaceHolder]="placeholder"
  [ngClass]="{ valid: control?.valid }"
  nzAllowClear
  (ngModelChange)="changeValue($event); change.emit($event)"
  [nzDropdownRender]="renderTemplate"
  (nzOnSearch)="searchValue($event)"
  nzMode="multiple"
>
<nz-option *ngFor="let item of listOfOption" [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
</nz-select>
    <ng-template #renderTemplate>
      <nz-spin *ngIf="isLoading"></nz-spin>
    </ng-template>
</div>

<ng-container *ngIf="!!showValidations">
  <app-validation
    *ngIf="(control?.dirty || isSubmitted) && control?.invalid"
    [control]="control"
    [maxLength]="maxLength"
  ></app-validation>
</ng-container>
